import { NavLink } from "react-router-dom";
import "./Footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-section">
          <h2>My Website</h2>
          <p>
  We provide E-commerce Solutions, Order Management Systems,
  SMS, Email, WhatsApp Business API, and Business Automation
  services to help businesses grow digitally.
</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
           <li><NavLink to="/">Home</NavLink></li>
<li><NavLink to="/about">About</NavLink></li>
<li><NavLink to="/services">Services</NavLink></li>
<li><NavLink to="/contact">Contact</NavLink></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <p>📍 New Delhi, India</p>
          <p>📧 info@shreebrains.com</p>
          <p>📞 +91 9971815737</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 My Website. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;